export const DOMAINS_GET = 'DOMAINS_GET';
export const DOMAIN_EDIT = 'DOMAIN_EDIT';
